import React from 'react'
import PropTypes from 'prop-types'
import { SvgIcon } from '@material-ui/core'

class PlusDoorIcon extends React.Component {
  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    return (
      <SvgIcon className={this.props.className}>
        {/* eslint-disable-next-line max-len */}
        <path id="svg_1" d="m16,11l0,1l0,1l2,0l-2,0l0,-2m-4,-8l7,0c1.11,0 2,0.89 2,2l0,14l1,0l0,2l-20,0l0,-2l8,0l0,-14c0,-1.11 0.89,-2 2,-2m4,3l0,7l2,0l0,-2l-3,0l3,-4l0,4l-5,-1z" />
        <rect stroke="null" id="svg_11" height="7.416595" width="1.811167" y="8.254453" x="3.584756" />
        <rect stroke="null" id="svg_13" height="1.799843" width="2.812568" y="11.062829" x="0.772564" />
        <rect stroke="null" id="svg_15" height="1.799843" width="2.788668" y="11.062829" x="5.395595" />
      </SvgIcon>
    )
  }
}

export default PlusDoorIcon
